import { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, ModalContext, SectionDivider, SidebarModal, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import realbaseApplications from '@functions/realbaseApplications'

import useManageUserApplicationsModal from './hooks/useManageUserApplicationsModal'

import ApplicationListItem from './ApplicationListItem'

const ManageUserApplicationsModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { updateUserApplications, closeModal } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { user } = modalPayload

  const manageUserApplicationsPayload = useManageUserApplicationsModal(user)
  const {
    callbacks: {
      toggleApplications,
      updateUser: updateFn,
    },
    enabledRealbaseApplications,
    updating,
    userForm: {
      entityState,
    },
  } = manageUserApplicationsPayload

  const userApplicationsPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Applications Assigned',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="User" titleSecondLine="Applications" />

      <SidebarModal.Content>
        <>
          <SidebarNoticeBox>
            <SidebarNoticeBox.Title>
              <FontAwesomeIcon color="orange" icon={faExclamationTriangle} />
              <Text color="orange" style={{ display: 'inline-block' }}>&nbsp;Application Access</Text>
            </SidebarNoticeBox.Title>

            <SidebarNoticeBox.Paragraph>
              This will limit or allow a user to access specific applications. This may effect the ability of a user to
              log in.
            </SidebarNoticeBox.Paragraph>
          </SidebarNoticeBox>

          <SectionDivider>APPLICATIONS</SectionDivider>

          {realbaseApplications.map((application) => {
            const checked = enabledRealbaseApplications.some(
              enabledApplicationKey => enabledApplicationKey === application?.key,
            )

            return (
              <ApplicationListItem
                application={application}
                callbacks={{ toggleApplications: () => toggleApplications(application.key) }}
                checked={checked}
                key={application.key}
              />
            )
          })}
        </>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateUserApplications(userApplicationsPayload)}
          size="large"
        >
          Save
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManageUserApplicationsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManageUserApplicationsModal.defaultProps = {
  modalKey: 'ManageUserApplicationsModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManageUserApplicationsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
